import { Box, BoxProps, ColorOptions, convertHexToRGBA, MaterialTextInput, Spacer, Text, TextProps } from '@jfs/ui-new'
import { useNavigation, useRoute } from '@react-navigation/core'

import React, { useEffect } from 'react'
import { useLazyApiData, useStores } from '../../../../data/store'
import { pages } from '../../../../utils/constants'
import { ActionButton } from '../../comps/ActionButton'
import { ProgressIndicator } from '../../comps/ProgressIndicator'
import { VerifyOTPModel } from '../../comps/VerifyOTPModel'
import { typesMappedValue } from '../../JioFinanceHub'

export const CheckEligibilityScreen = () => {
  const { sendCustomerOTP, validateCustomerOTP, checkEligibility, theme, mobileNumber } = useStores((root) => ({
    sendCustomerOTP: root?.jioPayFinanceHub?.sendCustomerOTP,
    validateCustomerOTP: root?.jioPayFinanceHub?.validateCustomerOTP,
    checkEligibility: root?.jioPayFinanceHub?.checkEligibility,
    mobileNumber: root?.transaction.payer.number,
    theme: root?.config?.merchantTheme,
  }))

  const [lazySendCustomerOtp, sendCustomerOtpHandler] = useLazyApiData(sendCustomerOTP)
  const [lazyValidateCustomerOTP, validateCustomerOTPHandler] = useLazyApiData(validateCustomerOTP)
  const [lazyCheckEligibility, checkEligibilityHandler] = useLazyApiData(checkEligibility)

  const [showVerifyOtpModel, setShowVerifyOtpModel] = React.useState(false)
  const [mobileNo, setMobileNo] = React.useState(mobileNumber ?? '')
  const navigation = useNavigation()
  const TYPE = useRoute().params as any
  useEffect(() => {
    if (checkEligibilityHandler.state === 'fulfilled') {
      setShowVerifyOtpModel(false)
      navigation.navigate(pages.eligibleBankList as never, TYPE as never)
    } else if (checkEligibilityHandler.state === 'rejected') {
      setShowVerifyOtpModel(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkEligibilityHandler.state])

  useEffect(() => {
    if (validateCustomerOTPHandler.state === 'fulfilled') {
      lazyCheckEligibility(mobileNo, TYPE)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validateCustomerOTPHandler.state])

  useEffect(() => {
    if (sendCustomerOtpHandler.state === 'fulfilled') {
      setShowVerifyOtpModel(true)
    }
  }, [sendCustomerOtpHandler.data, sendCustomerOtpHandler.state])

  return (
    <Box {...styles.container} backgroundColor={theme?.bodyBgColor as ColorOptions}>
      <ProgressIndicator data={['Eligibility', 'EMI Plan', 'Payment']} currentStep={1} />
      <Spacer size={38} direction="vertical" />
      <Text {...styles.infoText} color={convertHexToRGBA(theme.bodyTextColor, 50) as any}>
        Enter mobile number to check eligibility on {typesMappedValue[TYPE]}
      </Text>
      <Spacer size={24} />
      <MaterialTextInput
        value={mobileNo}
        onChangeText={(mobNo: any) => {
          mobNo = mobNo.replace(/[^0-9]/g, '')
          setMobileNo(mobNo)
        }}
        placeholder="Phone Number"
        leftComponent={
          <Text fontSize={12} fontFamily={'jioType-medium'} color={convertHexToRGBA(theme.bodyTextColor, 50) as any}>
            +91
          </Text>
        }
        maxLength={10}
        placeholderTextColor={convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions}
        color={theme?.bodyTextColor as ColorOptions}
        bottomLineColor={theme?.brandColor as ColorOptions}
        tintColor={theme?.brandColor as ColorOptions}
        testID="mobile-number"
      />
      <Spacer size={24} />
      <ActionButton
        title={'Get OTP'}
        disabled={mobileNo.length !== 10}
        onPress={() => lazySendCustomerOtp(mobileNo)}
        isLoading={sendCustomerOtpHandler.state === 'pending'}
      />
      {showVerifyOtpModel && (
        <VerifyOTPModel
          show={showVerifyOtpModel}
          isLoading={validateCustomerOTPHandler.state === 'pending' || checkEligibilityHandler.state === 'pending'}
          onDismiss={() => setShowVerifyOtpModel(false)}
          mobileNo={mobileNo}
          onOTPSubmit={(otp: any) => {
            lazyValidateCustomerOTP(mobileNo, otp)
          }}
          theme={theme}
          onResendOtpButtonPress={() => lazySendCustomerOtp(mobileNo)}
          isResendOtpLoading={sendCustomerOtpHandler.state === 'pending'}
        />
      )}
    </Box>
  )
}

const styles = {
  container: {
    p: 24,
    flexDirection: 'column',
    height: '100%',
  } as BoxProps,
  infoText: {
    fontSize: 14,
    fontFamily: 'jioType-medium',
    color: 'BRAND_COLOR_GRAY_1',
    lineHeight: 18,
  } as TextProps,
}
